import React from "react";
import { motion } from "framer-motion";

const BannerHeroSection = ({
  title,
  subtitle,
  bannerImage,
  height = "h-64 md:h-80 lg:h-96 !xl:h-[900px]",
  className = "",
  showOverlay = true,
  children,
}) => {
  return (
    <div className={`relative w-full flex justify-center items-center`}>
      {/* Background Banner Image with proper margins and centered */}
      <motion.div
        initial={{ opacity: 0, scale: 0.95 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.5, delay: 0.2 }}
        className="flex w-[90%] mx-4 md:mx-8 lg:mx-12 xl:mx-16 mb-6 md:mb-8 lg:mb-10 lg:mt-10"
      >
        <div
          className={`relative w-full ${height} overflow-hidden rounded-xl md:rounded-2xl shadow-lg`}
        >
          {/* Background Image - using object-cover to fill container but positioned to show complete image */}
          <img
            src={bannerImage}
            alt={title}
            className="w-full h-full object-cover object-center"
          />

          {/* Dark Overlay for Better Text Readability */}
          <div className="absolute inset-0 bg-gradient-to-r from-black/70 via-black/60 to-black/50"></div>

          {/* Text Overlay on Image */}
          <div className="absolute inset-0 flex flex-col items-center justify-center">
            <div className="text-center text-white px-4 sm:px-8 lg:px-16 max-w-4xl">
              <motion.h1
                className="text-2xl md:text-3xl lg:text-4xl xl:text-5xl font-bold mb-4 leading-tight"
                initial={{ opacity: 0, y: 30 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.8, delay: 0.2 }}
              >
                {title}
              </motion.h1>

              {subtitle && (
                <motion.p
                  className="text-lg md:text-xl lg:text-2xl font-medium opacity-90 mb-6"
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.8, delay: 0.4 }}
                >
                  {subtitle}
                </motion.p>
              )}

              {/* Additional Content (children) */}
              {children && (
                <motion.div
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.8, delay: 0.6 }}
                >
                  {children}
                </motion.div>
              )}
            </div>
          </div>
        </div>
      </motion.div>
    </div>
  );
};

export default BannerHeroSection;
